<template>
    <div class="bg1">
    <router-view></router-view>
    </div>
</template>

<script >
import { useI18n } from 'vue-i18n'
import {useRoute} from 'vue-router'
import {watch, onMounted, onBeforeMount, computed} from 'vue'
import emitter from '@/utils/event_bus.js'
import { Locale } from 'vant'
import store from '@/store/index.js'


export default {
  setup () {
    const initialUrl = window.location.href.split('#')[0]
    sessionStorage.setItem('fUrl', initialUrl)
    const route = useRoute()
    watch(() => route.path, () => {
      // console.log('监听一下路由', route.path)
    })

    const {messages, locale} = useI18n()
    const isShow = computed(() => (store.getters['appStore/isLoadingShow']) )
    const i18nData = computed(() => messages.value[locale.value])
    const darkStyle= computed(() => (store.getters['appStore/getDarkStyle'] === true ? 'dark' : 'light'))
    onBeforeMount(() => {
      emitter.off('i18nChange')
    })
    onMounted(()=> {
      emitter.on('i18nChange', (newVal) => {
        locale.value = newVal
        console.debug('i18nChange', newVal)
        // Locale.use(newVal, i18nData)
      })
      Locale.add(i18nData)
    })
    return {
      isShow,
      darkStyle,
      i18nData
    }
  }
}
</script>



<style lang="scss" scoped>
.bg1{
    background-size: cover;
    height: 100%;
    width: 100%;
}
.bg1::-webkit-scrollbar{
  display: none;
}
.van-loading {
  position: fixed !important;
  top: 50%;
  left: 50%;
  transform: translateX(-50%);
}
*{
  margin: 0;
  padding: 0;
}
</style>
